import React from 'react';
import s from "./TransparentButton.module.css";

type ButtonPropsType = {
    platformImg: string
    text: string
    platformLink: string
}

const TransparentButton = (props: ButtonPropsType) => {
    return (
        <a href={props.platformLink}
           target="_blank" className={s.button_wrapper}>
            <button className={s.transparent_button}>{props.text} <img src={props.platformImg} alt=""/></button>
        </a>
    );
};

export default TransparentButton;
